export enum DetailLeadPathEnum {
  process = 'tache',
  contacts = 'contacts',
  acquereurs = 'acquereurs',
  documents = 'documents',
  lots = 'lot'
}
